export default __webpack_public_path__ + "assets/images/aistudio/0538cbfa82034ccb4cecca74f3ba2bc2.png";